import { queryClient } from "@/queryClient"

export type UpdateUserBody = {
  firstName: string
  lastName: string
  email: string
  role: string | null
}

export const updateUser = async (
  id: string,
  params: UpdateUserBody
) => {
  await api.put(`/users/${id}/`, {
    body: params,
  })

  queryClient.invalidateQueries({
    queryKey: [USERS_QUERY_KEY],
  })

  // As list_roles.user_count may have changed
  queryClient.invalidateQueries({
    queryKey: [ROLES_QUERY_KEY],
  })

  return
}
